import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { paths } from 'constants/paths';

const RedirectTo404: FC = () => {
  const location = useLocation();

  return (
    <Navigate
      replace
      state={{ from: location }}
      to={paths.Root.children.NotFound}
    />
  );
};

export default RedirectTo404;
